<section class="content">
  <app-breadcrumbs type="newPostReport"></app-breadcrumbs>
  <div class="card">
    <div class="card-body-generate">
      <div class="avatar-content">
        <img class="avatar" src="assets/images/icons/face.png"/>
        <img class="icon-platform" src="assets/images/icons/instagram-2.png"/>
      </div>
      <h1>Generate new post report</h1>
<!--      <div class="alert-info mb-4">-->
<!--        <img class="alert-icon" src="assets/images/icons/warning.png"/>-->
<!--        <p class="alert-text">-->
<!--          Unfortunately, due to technical reasons, the addition of new audits is currently on hold. We apologize for the inconvenience.-->
<!--        </p>-->
<!--      </div>-->
      <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
        <div class="form-group add-profile-md">
          <div class="text-left">
            <p class="text-left text-medium mb-3">Enter Instagram post shortcode</p>
            <div class="pre-input-group mt-2">
              <div class="input-group-prepend">
                <div class="input-group-text">instagram.com/p/</div>
              </div>
              <input formControlName="post" (paste)="onPaste($event)" class="form-control" type="text" placeholder="Post shortcode...">
            </div>
          </div>
        </div>
        <div class="form-group text-group add-profile-sm">
          <p class="text-left text-medium mb-3">Enter Instagram post shortcode</p>
          <div>
            <input formControlName="post" (paste)="onPaste($event)" class="form-control w-100" type="text" placeholder="Post shortcode...">
          </div>
        </div>

        <div class="my-5">
          <button class="btn btn-blue btn-lg btn-animated" type="submit" [disabled]="!profileForm.valid">Generate report</button>
<!--          <button class="btn btn-blue btn-lg" type="submit" disabled>Generate report</button>-->
        </div>
      </form>
    </div>
  </div>
</section>

